module.exports = `${require.publicPath}home-img01.6ec622c8.png`;